import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { listProjectsListenerSaga } from './list-projects';

export function* rootSaga(): SagaIterator {
    yield all([fork(listProjectsListenerSaga)]);
}
